/** Allowlisted iOS device for App Store marketing screenshots (prod, 2026-07-04). */
export const MARKETING_DEMO_DEVICE_ID = "5417416d-6bed-46db-8d79-82caee7fa0ed";

export const MARKETING_DEMO_PREFERENCE_KEY = "screen0.marketingDemoMode";

/** Inclusive calendar-day span for fictitious history (~13–14 months). */
export const MARKETING_DEMO_DAY_COUNT = 400;

export const MARKETING_DEMO_RULE_ID_PREFIX = "marketing-demo-";
